<template>
  <div class="retail-test-3">
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />
    <div class="pa-4">
      <router-link :to="{ name: 'RetailTest2' }">
        Go to Retail Test 2
      </router-link>
    </div>
    <div class="pa-4">
      <router-link :to="{ name: 'RetailTest' }">
        Go to Retail Test
      </router-link>
    </div>
  </div>
</template>
<script>
import categoryMixins from "~/mixins/category";

export default {
  name: "RetailTest3",
  mixins: [categoryMixins],

  computed: {},
  mounted() {}
};
</script>
